<template>
  <div v-show="computedDataColumns.length" class="j-day--content">
    <div class="journal--bar-container">
      <div class="journal--bar-dates">
        <div class="left" @click="prevDay">
          <f-awesome icon="arrow-left"></f-awesome>
        </div>
        <div class="date no-select">
          <span class="text-underline" @click="clickDatePickerCounter++">
            <b>{{ nowRusDate }}</b>
          </span>
          <date-picker
            v-model="datePickerDate"
            :hideInput="true"
            :formClickImitate="clickDatePickerCounter"
          ></date-picker>
        </div>
        <div class="right" @click="nextDay">
          <f-awesome icon="arrow-right"></f-awesome>
        </div>
      </div>
      <div class="journal--bar-staff"></div>
      <div class="journal--bar-actions">
        <mode-journal
          @selectJournalMode="selectJournalMode"
          :modeList="modeJournalList"
          :modeActive="modeJournalActive"
        ></mode-journal>
      </div>
    </div>
    <div class="j-day--labels-container">
      <div class="j-day--labels-overflow">
        <labels-day
          :data="computedDataColumns"
          :staff="staff"
          :showDate="nowDate"
          @updateHideStaff="hideStaff"
        ></labels-day>
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from "../../libraries/Formatter";
import journalRepository from "../../../repositories/journal";

const formatter = new Formatter();

import ModeJournal from "./ModeJournal";
import LabelsDay from "./LabelsDay.vue";
import DatePicker from "../../DatePicker.vue";
import websocketEventBus from "../../../eventBus/websocketEventBus";
export default {
  name: "JournalDay",
  components: { ModeJournal, LabelsDay, DatePicker },
  data() {
    return {
      staffModel: "",
      nowDate: new Date(),
      nowRusDate: "",
      datePickerDate: '',
      clickDatePickerCounter: 0,
      dataColumns: [],
      hidedStaffIds: [],
      showLabels: false,
    };
  },
  props: {
    modeJournalList: Array,
    modeJournalActive: String,
    staff: Array,
  },
  watch: {
    datePickerDate: function(val){
      if(val !== ''){
        this.nowDate = formatter.rusDateToJSObject(val);
        this.setNowRusDate();
        this.renderDay();
      }
    },
    staff: function() {
      this.renderDay();
    },
  },
  computed: {
    computedDataColumns(){
      let result = [];
      if(this.hidedStaffIds.length > 0){
        for(let key in this.dataColumns){
          let hide = false;
          for(let hideKey in this.hidedStaffIds){
            if(+this.dataColumns[key].staff.id === +this.hidedStaffIds[hideKey]){
              hide = true;
            }
          }
          if(!hide){
            result[result.length] = this.dataColumns[key];
          }
        }
      }else{
        result = this.dataColumns;
      }
      // Вычислим пересечения и добавим данные для последующего рендера
      for(let key in result){
        if(result[key].labels.result == 'ok'){
          let response = result[key].labels.response;
          for(let label in response){
            if(response[label].type == 'enroll'){
              let intersectIdx = [];

              for(let labelIter in response){
                if(
                  (response[labelIter].type == 'enroll') &&
                  (
                    (response[label].time_from < response[labelIter].time_to && response[label].time_from >= response[labelIter].time_from) ||
                    (response[label].time_to <= response[labelIter].time_to && response[label].time_to > response[labelIter].time_from) ||
                    (response[label].time_from <= response[labelIter].time_from && response[label].time_to >= response[labelIter].time_to)
                  )
                ){
                  intersectIdx[intersectIdx.length] = labelIter;
                }
              }

              //  Поищем. Вдруг из списка intersectIdx есть касательные пересечения через 1 запись
              // Например, когда из 3 записей только одна пересекается с двумя.
              // Прогоним алгоритм до 10 раз пока не найдем все
              for(let i = 0; i <= 10; i++){
                let existsIntersect = false;

                for(let intersectKey in intersectIdx){
                  for(let indirectLabel in response){
                    if(intersectIdx[intersectKey] === indirectLabel){
                      for(let indirectIterLabel in response){
                        if(
                          (response[indirectIterLabel].type == 'enroll') &&
                          (!intersectIdx.includes(indirectIterLabel)) &&
                          (
                            (response[indirectLabel].time_from < response[indirectIterLabel].time_to && response[indirectLabel].time_from >= response[indirectIterLabel].time_from) ||
                            (response[indirectLabel].time_to <= response[indirectIterLabel].time_to && response[indirectLabel].time_to > response[indirectIterLabel].time_from) ||
                            (response[indirectLabel].time_from <= response[indirectIterLabel].time_from && response[indirectLabel].time_to >= response[indirectIterLabel].time_to)
                          )
                        ){
                          intersectIdx[intersectIdx.length] = indirectIterLabel;
                          existsIntersect = true;
                        }
                      }
                    }
                  }
                }
                if(!existsIntersect){
                  break;
                }
              }

              // Отсортируем по порядку. Иначе intersectIndex у каждого будет некорректный
              intersectIdx.sort(function(a, b) {
                return a - b;
              });

              if(intersectIdx.length > 1){
                result[key].labels.response[label].existsIntersect = true;
                result[key].labels.response[label].intersectCount = intersectIdx.length;

                for(let intersectKey in intersectIdx){
                  if(label === intersectIdx[intersectKey]){
                    result[key].labels.response[label].intersectIndex = +intersectKey +1;
                  }
                }
              }else{
                result[key].labels.response[label].existsIntersect = false;
              }

            }
          }
        }
      }

      return result;
    }
  },
  methods: {
    hideStaff(staffIds){
      this.hidedStaffIds = staffIds;
    },
    selectJournalMode(val) {
      this.$emit("selectJournalMode", val);
    },
    renderDay() {
      this.dataColumns = [];

      for (let key in this.staff) {
        let staffObj = {};
        staffObj.staff = this.staff[key];
        staffObj.labels = {};
        this.dataColumns.push(staffObj);
      }
      this.setNowRusDate();
      this.getLabels();
    },
    getLabels() {
      this.showLabels = false;

      let staffIds = [];
      for (let key in this.dataColumns) {
        staffIds[staffIds.length] = this.dataColumns[key].staff.id;
      }
      const phpDate = formatter.jsObjectToPhp(this.nowDate);

      journalRepository.getLabelsByStaffList({
        'staff_ids': JSON.stringify(staffIds),
        'date': phpDate
      }).then(resp => {
        for (let key in resp.data) {
          for (let col in this.dataColumns) {
            if (+key === +this.dataColumns[col].staff.id) {
              this.$set(this.dataColumns[col], "labels", resp.data[key]);
            }
          }
        }
        this.showLabels = true;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    setNowRusDate() {
      let result = "";
      if (this.nowDate != "") {
        let phpDate = formatter.jsObjectToPhp(this.nowDate);
        result = formatter.phpDateToShortString(phpDate);
      }
      this.nowRusDate = result;
    },
    prevDay() {
      this.nowDate.setDate(this.nowDate.getDate() - 1);
      this.setNowRusDate();
      this.renderDay();
    },
    nextDay() {
      this.nowDate.setDate(this.nowDate.getDate() + 1);
      this.setNowRusDate();
      this.renderDay();
    },
    websocketSaveEnrollObserve() {
      this.getLabels();
    },
    websocketDeleteEnrollObserve(data) {
      const phpDate = formatter.jsObjectToPhp(this.nowDate);
      if (data.data.date === phpDate) {
        this.getLabels();
      }
    },
  },
  created() {
    if(this.staff.length > 0){
      this.renderDay();
    }
    websocketEventBus.subscribeToSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.subscribeToDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
  beforeDestroy() {
    websocketEventBus.unsubscribeFromSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.unsubscribeFromDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
};
</script>

<style scoped lang="less">
.j-day--labels-container {
  margin-top: 5px;
  .j-day--labels-overflow {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;

    .item {
      min-width: 230px;
      width: 350px;
      margin-right: 8px;

      .staff {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        flex-direction: row;

        .logo {
          width: 30%;
          text-align: center;
          img {
            width: 40px;
          }
        }
        .name {
          width: 70%;
          height: 44px;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
